import { SiteDashboardWidgetData, SiteDashboardWidgetError } from "~/api/Api";

import {
  RenderableWidgetOrError,
  WidgetConfig,
} from "../types/RenderableWidget.type";
import { toRenderableWidget } from "./toRenderableWidget";

// Pair each widget config with its data by ID. Order-independent —
// neither the config list nor the data list has to be sorted, and the
// data list can include extras (we just ignore them). A config without
// matching data throws, since silently dropping it would leave the
// user with a missing widget and no clue why.
export const joinWidgets = (
  widgetConfigs: WidgetConfig[],
  data: (SiteDashboardWidgetData | SiteDashboardWidgetError)[],
): RenderableWidgetOrError[] => {
  const dataById = new Map(data.map((d) => [d.id, d]));

  return widgetConfigs.map((widgetConfig) => {
    const widgetData = dataById.get(widgetConfig.id);

    if (!widgetData) {
      throw new Error(
        `No widget data returned for config id "${widgetConfig.id}"`,
      );
    }

    return toRenderableWidget(widgetConfig, widgetData);
  });
};
